import { Modal, ModalBody, ModalFooter } from '@coolblue-development/freddy';
import { ResolvedGA4Trigger } from '@coolblue-development/ga4-events';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useFreddyTranslations } from '@coolblue-development/next-design-system-utils/client';
import type { InitialProduct } from '@features/product/components/Collection/Collection.types';
import { ReactNode } from 'react';

type MobileModalProps<T> = {
  isInternalUser?: boolean;
  isOpen: boolean;
  setIsOpen: (state: boolean) => void;
  setSelectedProduct: (product: T) => void;
  initialSelectedProduct: T;
  trackingEvent?: ResolvedGA4Trigger;
  collectionTitle: string;
  modalBody: ReactNode;
  modalFooter: ReactNode;
};

export const MobileModal = <T extends InitialProduct>({
  isInternalUser = false,
  isOpen,
  setIsOpen,
  setSelectedProduct,
  initialSelectedProduct,
  trackingEvent,
  collectionTitle,
  modalBody,
  modalFooter
}: MobileModalProps<T>) => {
  const modalTranslations = useFreddyTranslations('modal');
  const { trackEvent } = useAnalytics();

  return (
    <Modal
      {...(isInternalUser && { 'data-cy': 'modal-collection' })}
      translations={modalTranslations}
      open={isOpen}
      onClose={() => {
        setIsOpen(false);
        setSelectedProduct(initialSelectedProduct); // Reset values when closed
        if (trackingEvent) {
          trackEvent(trackingEvent);
        }
      }}
      placement='bottom'
      title={collectionTitle}
      size='xlarge'
      body={<ModalBody>{modalBody}</ModalBody>}
      footer={<ModalFooter>{modalFooter}</ModalFooter>}
    />
  );
};
